import { render, staticRenderFns } from "./SpeakerInformation.vue?vue&type=template&id=5486e656&scoped=true&"
import script from "./SpeakerInformation.vue?vue&type=script&lang=js&"
export * from "./SpeakerInformation.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerInformation.vue?vue&type=style&index=0&id=5486e656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486e656",
  null
  
)

export default component.exports